import React from 'react';
import { Image as ImageIcon, Video, Heart } from 'lucide-react';

const AboutUsMedia = () => {
  const photos = [
    {
      id: 1,
      url: 'https://customer-assets.emergentagent.com/job_exact-replica-167/artifacts/xja6lljf_Graduation%20for%20CPP.jpg',
      title: 'Compassion Prison Project Graduation',
      description: 'Program graduates celebrating transformation with certificates and community support'
    },
    {
      id: 2,
      url: 'https://customer-assets.emergentagent.com/job_exact-replica-167/artifacts/o8bvbklx_Photo%20of%20Juan%201.PNG',
      title: 'J\'Wells Speaking',
      description: 'Founder J\'Wells sharing powerful testimony and truth at graduation ceremony'
    },
    {
      id: 3,
      url: 'https://customer-assets.emergentagent.com/job_exact-replica-167/artifacts/y167p9qj_photo%20of%20juan%20web.jpg',
      title: 'Community Connection',
      description: 'Authentic moments of healing and connection between participants'
    },
    {
      id: 4,
      url: 'https://customer-assets.emergentagent.com/job_exact-replica-167/artifacts/6r56u2sv_photo%20of%20juan%20%28website%29.jpg',
      title: 'Healing Through Movement',
      description: 'Group participation in embodiment work and joyful community building'
    }
  ];

  return (
    <section id="about-media" className="relative py-24 bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full px-6 py-2 mb-6">
            <Heart className="w-5 h-5 text-[#D4AF37]" />
            <span className="text-[#D4AF37] font-bold text-sm">OUR IMPACT</span>
          </div>
          <h2 className="text-5xl sm:text-6xl md:text-7xl font-bold text-white mb-6" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
            STORIES OF
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#FFD700]">
              TRANSFORMATION
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Witnessing healing through music, community, and the power of shared humanity
          </p>
        </div>

        {/* Mission Statement */}
        <div className="mb-16 bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border border-[#D4AF37]/20 rounded-2xl p-8 md:p-12">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold text-white mb-6" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              WHO WE ARE
            </h3>
            <p className="text-xl text-gray-300 leading-relaxed mb-6">
              40 Songs and a Mic is more than a record label. We are a movement dedicated to using gospel and trauma-informed hip-hop as tools for emotional healing, spiritual growth, and trauma recovery.
            </p>
            <p className="text-lg text-gray-400 leading-relaxed">
              Through our partnership with the Compassion Prison Project and trauma-informed programs across California, we bring music, testimony, and community expression to those who need it most. Every song, every workbook, every graduation ceremony is a testament to the power of healing through authentic storytelling.
            </p>
          </div>
        </div>

        {/* Photo Gallery */}
        <div className="mb-12">
          <div className="flex items-center space-x-3 mb-8">
            <ImageIcon className="w-6 h-6 text-[#D4AF37]" />
            <h3 className="text-3xl font-bold text-white" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              PROGRAM HIGHLIGHTS
            </h3>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {photos.map((photo) => (
              <div
                key={photo.id}
                className="group relative bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border border-[#D4AF37]/20 rounded-xl overflow-hidden transform hover:scale-105 transition-all duration-300 hover:border-[#D4AF37]"
              >
                <img
                  src={photo.url}
                  alt={photo.title}
                  className="w-full h-80 object-contain bg-[#0a0a0a]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h4 className="text-xl font-bold text-white mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                      {photo.title}
                    </h4>
                    <p className="text-gray-300 text-sm">
                      {photo.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Partnership Section */}
        <div className="bg-gradient-to-r from-[#1a1a1a] via-[#D4AF37]/10 to-[#1a1a1a] border border-[#D4AF37]/30 rounded-2xl p-8 md:p-12">
          <div className="text-center">
            <h3 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              IN PARTNERSHIP WITH COMPASSION PRISON PROJECT
            </h3>
            <p className="text-lg text-gray-300 mb-6 max-w-3xl mx-auto leading-relaxed">
              Through our collaboration with the Compassion Prison Project, we bring trauma-informed healing programs, music, and community support to incarcerated individuals across California. Together, we're creating spaces for transformation, dignity, and hope.
            </p>
            <div className="inline-block bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-lg px-6 py-3">
              <p className="text-[#D4AF37] font-bold">compassionprisonproject.org</p>
            </div>
          </div>
        </div>

        {/* Video Placeholder */}
        <div className="mt-12">
          <div className="flex items-center space-x-3 mb-8">
            <Video className="w-6 h-6 text-[#D4AF37]" />
            <h3 className="text-3xl font-bold text-white" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              VIDEOS & PERFORMANCES
            </h3>
          </div>
          
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border-2 border-[#D4AF37]/30 rounded-2xl p-12 text-center">
            <Video className="w-16 h-16 text-[#D4AF37] mx-auto mb-4" />
            <p className="text-xl text-gray-300 mb-2">
              Video content coming soon
            </p>
            <p className="text-gray-500">
              Live performances, testimony, and transformation stories
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsMedia;
